<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Member phone change</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content style="padding-bottom: 0px;">
    <div class="row g-2 justify-content-between phone-field">
        <mat-form-field appearance="outline" class="country-code">
          <mat-label>Country Code</mat-label>
          <mat-select
          [(ngModel)]="selectedCountryCode"
          required
          (selectionChange)="onCountrySelected($event)"
        >
          <mat-select-trigger>
            {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                {{ "(" + selectedCountryCode.dial_code + ")" }}
          </mat-select-trigger>
          
          <mat-option>
            <ngx-mat-select-search
              noEntriesFoundLabel="no results found"
              name="countrysearch"
              placeholderLabel="Enter country name"
              [formControl]="searchString"
              (keyup)="onKey()"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let country of countryList" [value]="country">
            {{ country.flag }} {{ country.name }}
            {{ "(" + country.dial_code + ")" }}
          </mat-option>
        </mat-select>
        </mat-form-field>
        <mat-form-field class="mobile_form" appearance="outline">
          <mat-label>Phone</mat-label>
          <input
            [(ngModel)]="newMemberData.customerPh"
            matInput
            type="tel"
            smNumericOnly
            minLength="3"
            maxlength="17"
          />
          <mat-hint
            style="color: red; font-size: 13px"
            align="end"
            *ngIf="
              newMemberData.customerPh &&
              newMemberData.customerPh != '' &&
              newMemberData.customerPh.length < 3
            "
            >Enter a valid phone number.</mat-hint
          >
        </mat-form-field>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
   <div class="enrolled_memder">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        formChecker()
      "
      (click)="onPost()"
    >
      Confirm
    </button>
  </div>
  </mat-dialog-actions>